import React from "react";
import tw from "twin.macro";
import { useState } from "react";


const Container = tw.div`relative w-full mx-6`;
const FlexContainer = tw.div`flex items-center w-full bg-red-500`;
const FormContainer = tw.div` bg-white  md:mx-16 rounded-xl p-4 md:p-8 mb-8`;;
const InputContainer = tw.div`relative flex items-center py-5 w-full`;
const Label = tw.div`text-gray-900 tracking-wide font-semibold   text-base md:text-2xl w-4/12 md:w-3/12`;
const Input = tw.input`p-2 md:p-4 rounded-lg bg-gray-200 w-6/12 md:w-6/12`;
const Actions = tw.div`flex flex-col sm:flex-row justify-center mt-8 ml-0 mb-2 mr-8 lg:justify-end `;
const ActionsMain = tw.div`flex flex-col sm:flex-row justify-center mt-8  lg:justify-center `;

const Link1 = tw.a`bg-blue-200 text-blue-900 px-6 py-2 rounded-lg  text-base md:text-2xl font-semibold`;
const Link2 = tw.a`bg-blue-200 text-blue-900 mx-4 my-2 px-6 py-2 rounded-lg  text-base md:text-2xl font-semibold`;
const FormButton = tw.a`bg-blue-200 text-blue-900 ml-4 px-6 py-2 rounded-lg text-base md:text-2xl font-semibold`;
const Heading = tw.div`text-2xl md:text-3xl font-bold pb-14`;

export default () => {

  const [show_upload_modal, set_show_upload_modal] = useState(false);

  return (
    <Container>


      <FormContainer>

        <Heading>ADD VENDING</Heading>
        <form action="#">
          <InputContainer>
            <Label htmlFor="name-input">Vending Machine</Label>
            <Input
              id="full-name"
              type="text"
              name="fullname"
            />
          </InputContainer>


          <InputContainer>
            <Label htmlFor="name-input">QR Code Id</Label>

            <Input
              id="phonenumber"
              type="text"
              name="phonenumber"
            />
            <FormButton href="#">Add</FormButton>
          </InputContainer>

          <ActionsMain>
            <Link2 href="#" onClick={() => set_show_upload_modal(true)}>Create</Link2>
            <Link2 href="#">Launch</Link2>
          </ActionsMain>
        </form>
      </FormContainer>




      {show_upload_modal === true ? (


        <FormContainer>

          <Heading>ADD VENDING</Heading>
          <form action="#">
            <InputContainer>
              <Label htmlFor="name-input">Vending Machine</Label>
              <Input
                id="full-name"
                type="text"
                name="fullname"
              />
            </InputContainer>

            <InputContainer>
              <Label htmlFor="name-input">Name</Label>
              <Input
                id="company-name"
                type="text"
                name="companyname"
              />
            </InputContainer>

            <InputContainer>
              <Label htmlFor="name-input">QR Code Id</Label>

              <Input
                id="phonenumber"
                type="text"
                name="phonenumber"
              />
              <FormButton href="#">Add</FormButton>
            </InputContainer>

            <InputContainer>
              <Label htmlFor="name-input">MQTT</Label>
              <Input
                id="category"
                type="text"
                name="category"
              />
            </InputContainer>
            <InputContainer>
              <Label htmlFor="name-input">User Name</Label>
              <Input
                id="minimum-service-charge"
                type="text"
                name="minimumservicecharge"
              />
            </InputContainer>

            <InputContainer>
              <Label htmlFor="name-input">Password</Label>
              <Input
                id="minimum-service-charge"
                type="password"
                name="minimumservicecharge"
              />
            </InputContainer>
            <InputContainer>
              <Label htmlFor="name-input">Publish Topic</Label>
              <Input
                id="minimum-service-charge"
                type="text"
                name="minimumservicecharge"
              />
            </InputContainer>
            <InputContainer>
              <Label htmlFor="name-input">Subscribe Topic</Label>
              <Input
                id="minimum-service-charge"
                type="text"
                name="minimumservicecharge"
              />
              <FormButton href="#">Add</FormButton>
            </InputContainer>


            <Actions>
              <Link1 href="#">Create</Link1>
            </Actions>
          </form>
        </FormContainer>

      ) : null}

    </Container>
  );
};
